import React from 'react';
import { getCreator, isNewProduct } from '../../utils/catalog';
import { daysLeft, isLeavingSoon } from '../../utils/exhibition';
import type { Product } from '../../types/catalog';
export function ProductTags({
  product
}: {
  product: Product;
}) {
  const creator = getCreator(product.creatorId);
  const tags: {
    label: string;
    className: string;
  }[] = [];
  if (creator && isLeavingSoon(creator)) {
    const left = daysLeft(creator);
    tags.push({
      label: `Part dans ${left} j`,
      className: 'bg-clay text-paper'
    });
  }
  if (product.stock === 1) {
    tags.push({
      label: 'Pièce unique',
      className: 'bg-paper text-ink'
    });
  } else if (isNewProduct(product) && tags.length === 0) {
    tags.push({
      label: 'Nouveau',
      className: 'bg-paper text-ink'
    });
  }
  if (tags.length === 0) return null;
  return <div className="pointer-events-none absolute left-3 top-3 flex flex-col items-start gap-1.5" data-id="element-569" data-mp="1cvosb72mqtos">
      {tags.map(t => <span key={t.label} className={`rounded-full px-2.5 py-1 text-[11px] font-medium ${t.className}`} data-id="element-570" data-mp="17wvf7fr994p5">
          {t.label}
        </span>)}
    </div>;
}